import { Box, Divider } from "@mui/material";
import { GridColDef, GridColumnMenu, GridColumnMenuContainer } from "@mui/x-data-grid-pro";
import {SyntheticEvent} from "react";

interface Props
{
    hideMenu: (event: SyntheticEvent<Element, Event>) => void
    currentColumn: GridColDef
    open: boolean
}
export default function SheetColumnMenu({ hideMenu, currentColumn, open }: Props)
{
    return <Box>
        <GridColumnMenuContainer hideMenu={hideMenu} currentColumn={currentColumn} open={open}>
            <Divider />
            <GridColumnMenu hideMenu={hideMenu} currentColumn={currentColumn} open={open}/>
        </GridColumnMenuContainer>
    </Box >
}